import { Injectable } from '@angular/core';
import { LayoutState } from '../reducers/layout.reducers';
import { Observable } from 'rxjs';
import { Store } from '@ngrx/store';
import { layoutChanged } from '../actions';
import { selectBackground } from '../selectors';

@Injectable({
  providedIn: 'root',
})
export class LayoutFacade {
  constructor(private store: Store<LayoutState>) {}

  public selectBackground$(): Observable<boolean> {
    return this.store.select(selectBackground);
  }

  public layoutChanged(payload: Partial<LayoutState>): void {
    this.store.dispatch(layoutChanged(payload));
  }
}
